import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchAnnouncements } from "./slices/AnnouncementSlice";
import {
  fetchBanners,

} from "./slices/BannerSlice"; // Adjust import path if needed
import { Link } from "react-router-dom";
import "./styles/LandingHeader.css";

const LandingHeader = () => {
  const dispatch = useDispatch();
  const { banners } = useSelector((state) => state.banners);

  const [menuOpen, setMenuOpen] = useState(false);
  const businessId = "6709f0331882028713f23319";
  useEffect(() => {
    // Fetch existing banners when the component mounts
    dispatch(fetchBanners(businessId));
  }, [dispatch, businessId]);
  useEffect(() => {
    if (businessId) dispatch(fetchAnnouncements(businessId));
  }, [dispatch, businessId]);
  const toggleMenu = () => setMenuOpen((prev) => !prev);
  return (
    <>


      <header className="landing-header">
        {banners?.length > 0 && (
          <div className="header-banner">
            {banners[0].title}
          </div>
        )}
        <div className="header-content">
          <Link
            to="/"
            className="restaurant-name"
            onClick={() => setMenuOpen(false)}
          >
            Chai n Chill
          </Link>
          <button
            className="hamburger"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className={`bar ${menuOpen ? "open" : ""}`}></span>
            <span className={`bar ${menuOpen ? "open" : ""}`}></span>
            <span className={`bar ${menuOpen ? "open" : ""}`}></span>
          </button>

          <div className={`header-titles ${menuOpen ? "show" : ""}`}>
            <div className="sub-headline-row">
              <Link to="/menu" className="sub-title" onClick={toggleMenu}>
                Menu
              </Link>
              <Link to="/about" className="sub-title" onClick={toggleMenu}>
                About
              </Link>
              <Link to="/reserve" className="sub-title" onClick={toggleMenu}>
                Gallery
              </Link>
              <Link to="/contact-us" className="sub-title" onClick={toggleMenu}>
                Contact Us
              </Link>
              <Link to="/contact-us" className="sub-title-cat" onClick={toggleMenu}>
                WE DO CATERING!
              </Link>
            </div>
          </div>

          <div className="social-icons">
            <a href="https://pages.cloudflare.com" className="icon" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://pages.cloudflare.com" className="icon" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://pages.cloudflare.com" className="icon" aria-label="TikTok">
              <i className="fab fa-tiktok"></i>
            </a>
          </div>
        </div>
      



      </header>

    </>
  );
};

export default LandingHeader;
